import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'shared/components/Link';
import Popover from 'researcher/components/Popover';
import { T } from 'shared/helper/translate';
import useArchiveEntity, { ConfirmArchiveModal } from 'researcher/hooks/use-archive-entity';
var DigitalEditingActions = function DigitalEditingActions(_ref) {
  var archiveDigitalEdit = _ref.archiveDigitalEdit,
    digitalEdit = _ref.digitalEdit,
    pathname = _ref.pathname,
    downloading = _ref.downloading,
    getDownloadUrl = _ref.getDownloadUrl;
  if (!digitalEdit.finishedProcessing) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T, {
      source: "digital-edit-processing"
    }), /*#__PURE__*/React.createElement(Popover, {
      content: "digital-editing-processing-popover"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "ms-1 text-muted",
      icon: "fa-solid fa-circle-info"
    })));
  }
  var _useArchiveEntity = useArchiveEntity({
      archiveEntity: archiveDigitalEdit
    }),
    descriptor = _useArchiveEntity.descriptor,
    handleArchive = _useArchiveEntity.handleArchive,
    showConfirm = _useArchiveEntity.showConfirm,
    toggleShowConfirm = _useArchiveEntity.toggleShowConfirm;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "float-end"
  }, digitalEdit.failed ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "text-danger d-block d-lg-inline me-0 me-lg-1",
    onClick: function onClick() {
      return toggleShowConfirm(digitalEdit.identity, digitalEdit.file.name);
    }
  }, /*#__PURE__*/React.createElement(Popover, {
    content: "de-delete-file-tooltip"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-1",
    icon: "fa-solid fa-trash",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "delete"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-lg-inline me-0 me-lg-1"
  }, "\xB7"), /*#__PURE__*/React.createElement(T, {
    source: "automated-edit-failure"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "/api/order-form/from-digital-edit/".concat(digitalEdit.identity),
    className: "d-block d-lg-inline me-0 me-lg-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Get Professional Editing"
  })), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-lg-inline"
  }, "\xB7"), /*#__PURE__*/React.createElement(Link, {
    to: {
      state: {
        pathname: pathname
      },
      pathname: "/researcher/digital-editing/details/".concat(digitalEdit.identity)
    },
    className: "mx-0 mx-lg-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "See details"
  })), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-lg-inline"
  }, "\xB7"), digitalEdit.completed ? /*#__PURE__*/React.createElement(React.Fragment, null, downloading(digitalEdit) ? /*#__PURE__*/React.createElement("span", {
    className: "d-block d-lg-inline text-nowrap ms-0 ms-lg-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "me-2",
    spin: true,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Downloading..."
  })) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return getDownloadUrl(digitalEdit.identity, digitalEdit.file.name);
    },
    className: "d-block d-lg-inline text-nowrap ms-0 ms-lg-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Download edited manuscript"
  }))) : null)), /*#__PURE__*/React.createElement(T, {
    source: "digital-edit-upload-status",
    params: {
      date: digitalEdit.createdAt
    }
  }), /*#__PURE__*/React.createElement(ConfirmArchiveModal, {
    descriptor: descriptor,
    handleArchive: handleArchive,
    showConfirm: showConfirm,
    toggleShowConfirm: toggleShowConfirm,
    terms: {
      confirmation: 'de-delete-file-confirmation',
      description: 'de-delete-file-desc',
      title: 'de-delete-file-title',
      yesText: 'de-delete-file-yes-text'
    }
  }));
};
export default DigitalEditingActions;